

export default function CloseIconBig({ className }) {
    return (
        <svg className={className} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.123 5L5.12305 15M5.12305 5L15.123 15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}